import type { TokenAcessoDto } from '@nexital/shared';
import { ErroApi } from '../application/portas';
import type { ApiAcesso } from '../application/sessao';
import { tokenRecaptcha } from './recaptcha';

/** Login, renovação e saída. O cookie de renovação (httpOnly) é enviado pelo navegador; o JS nunca o vê. */
export class ApiAcessoHttp implements ApiAcesso {
  async entrar(email: string, senha: string): Promise<TokenAcessoDto> {
    const recaptcha = await tokenRecaptcha('login');
    const resposta = await fetch('/api/auth/entrar', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email, senha, recaptcha }),
    });
    const json = await resposta.json().catch(() => ({}));
    if (!resposta.ok) throw new ErroApi(resposta.status, json.mensagem ?? `Erro ${resposta.status}`);
    return json;
  }

  async renovar(atividadeEm?: number): Promise<TokenAcessoDto | null> {
    const resposta = await fetch('/api/auth/renovar', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ atividadeEm }),
    });
    if (resposta.status === 401) return null;
    if (!resposta.ok) throw new ErroApi(resposta.status, 'Não foi possível renovar a sessão.');
    return resposta.json();
  }

  async sair() {
    await fetch('/api/auth/sair', { method: 'POST' });
  }
}
